module.exports = __webpack_public_path__ + "img/istanbul.34c5ef52.png";